import { render, staticRenderFns } from "./SVGPlus.vue?vue&type=template&id=7c99e35e&scoped=true&"
import script from "./SVGPlus.vue?vue&type=script&lang=js&"
export * from "./SVGPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c99e35e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c99e35e')) {
      api.createRecord('7c99e35e', component.options)
    } else {
      api.reload('7c99e35e', component.options)
    }
    module.hot.accept("./SVGPlus.vue?vue&type=template&id=7c99e35e&scoped=true&", function () {
      api.rerender('7c99e35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPlus.vue"
export default component.exports